import { CanLoad, Route } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { isAdmin } from '../utils/jwt.utils';

export class AdminGuard implements CanLoad {
  canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
    return isAdmin();
  }
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/guards/admin.guard.ts